import { Base64 } from '@hh/global.js'
const HYDRATION_CACHE = {}
const HYDRATION_SMALL_CACHE = {}
const SKELETON_ATTRUBUTES = [
  'data-product-href',
  'data-product-image-primary',
  'data-product-image-secondary',
  'data-product-title',
  'data-product-description',
  'data-product-price',
]

class ProductCard extends HHBaseElement {
  constructor() {
    super()

    this._hydrated = !this.shouldHydrate
    this._skeletonTemplate = document.getElementById('skeleton-product-card')

    this.mql = window.matchMedia('(min-width: 768px)')

    this.mql = window.matchMedia('(min-width: 992px)')
    this.mql_m = window.matchMedia('(min-width: 1200px)')
    this.mql_l = window.matchMedia('(min-width: 1440px)')
    this._selectItems = this._selectItems.bind(this)
    this._updateCardVariantState = this._updateCardVariantState.bind(this)
    this._updateSlideoutVariant = this._updateSlideoutVariant.bind(this)
    this._handleSwatchRadioChange = this._handleSwatchRadioChange.bind(this)
    this._handleSwatchRadioKeydown = this._handleSwatchRadioKeydown.bind(this)
    this._clearActiveButton = this._clearActiveButton.bind(this)
    this._updateSlideoutContent = this._updateSlideoutContent.bind(this)
    this._formatCurrency = this._formatCurrency.bind(this)
    this._handleize = this._handleize.bind(this)
    this._createSwatchGroupSlider = this._createSwatchGroupSlider.bind(this)
    this._createSwatchFilterButton = this._createSwatchFilterButton.bind(this)
    this._handleSlideoutFilter = this._handleSlideoutFilter.bind(this)
    this._handleSlideoutFilterKeydown =
      this._handleSlideoutFilterKeydown.bind(this)
    this._swapSlideoutFeaturedVariant =
      this._swapSlideoutFeaturedVariant.bind(this)
    this._updateSwatchesCount = this._updateSwatchesCount.bind(this)
    this._handleInCartToggle = this._handleInCartToggle.bind(this)
    this.miniCart = document.querySelector('.mini-cart')
    this.miniCartParent = this.closest('mini-cart')
  }

  _initSelectors() {
    this.sizeButtons = [
      ...this.querySelectorAll('.size-variants-container button'),
    ]
    this.selectedVariantInput = this.querySelector('.js-selected-variant')
    this.slideoutToggle = this.querySelector('.swatch-count-container')
    this.slideoutToggleVisibleCount = this.querySelector('.js-swatch-count')
    this.slideoutToggleHiddenCount = this.querySelector('.js-sr-swatch-count')
    this.productForm = [...this.querySelectorAll('form')]
    this.swatchSliderCreated = false

    this.imageParent = this.querySelector('.product-card__image-container')
    this.imageOne = this.querySelector(
      '.product-card__image-one .img'
    )
    this.imageTwo = this.querySelector(
      '.product-card__image-two .img'
    )
    this.mobileImage = this.querySelector(
      '.product-card__mobile-image .img'
    )

    this.slideout = document.querySelector('.slideout-swatch-selector ')
    if (this.slideout) {
      this.slideoutSwatchContainer = this.slideout.querySelector(
        '.swatches-container'
      )

      this.slideoutTitle = document.querySelector(
        '.slideout-swatch-selector .product__title'
      )
      this.slideoutCategories = document.querySelector(
        '.slideout-swatch-selector .swatch-category-slider'
      )
      this.slideoutSwatches = document.querySelector(
        '.slideout-swatch-selector .swatches-container ul'
      )
      this.slideoutHeader = document
        .querySelector('.slide-panel--slideout[slideout-id="swatch-selector"]')
        .shadowRoot.querySelector('.slide-panel__title-container')
      this.slideoutPanel = document
        .querySelector('.slide-panel--slideout[slideout-id="swatch-selector"]')
        .shadowRoot.querySelector('.slide-panel__panel')

      this.reviewCount = this.querySelector('.oke-sr-count-number')
      if (this.reviewCount) {
        this.reviewCount.innerHTML = `${this.reviewCount.innerHTML}<span class='visually-hidden'>Reviews</span>`
      }

      this.slideTabPanel = this.slideout.querySelector('.js-slideout-swatches-container')
    }
  }

  connectedCallback() {
    this._initSelectors()
    if (this.shouldHydrate) {
      return this._hydrate()
    }
    this._selectItems()
    this._updateSwatchesCount()
    this._attachListeners()
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'is-search-product' && newValue === 'true') {
      await this._hydrate().then(() => {
        setTimeout(() => {
          this._attachListeners()
        }, 1000)
      })
    }
  }

  async _hydrate() {
    const cacheVar =
      this.cardSize === 'small' ? HYDRATION_SMALL_CACHE : HYDRATION_CACHE
    const viewParam = 'product-card'

    if (cacheVar[this.productHandle]) {
      this.innerHTML = cacheVar[this.productHandle]

      return this._handleHydration()
    } else {
      if (this.cardSize !== 'small') this._renderSkeleton()
      const baseUrl = window.routes.root_url.endsWith('/')
        ? window.routes.root_url
        : `${window.routes.root_url}/`
      const request = await fetch(
        `${baseUrl}products/${this.productHandle}?view=${viewParam}`
      )
      const container = document.createElement('div')
      const returnedHtml = await request.text()
      container.innerHTML = returnedHtml
      const productCardNode = container.querySelector(viewParam)
      cacheVar[this.productHandle] = productCardNode.innerHTML
      this.innerHTML = cacheVar[this.productHandle]
      this.setAttribute(
        'product-id',
        productCardNode.getAttribute('product-id')
      )
      this._hydrated = true
      return this._handleHydration()
    }
  }
  _renderSkeleton() {
    if (!this._skeletonTemplate) return null
    const contents = this._skeletonTemplate.cloneNode(true)
    this.innerHTML = contents.innerHTML
    SKELETON_ATTRUBUTES.forEach((attr) => {
      const data = this.getAttribute(attr)
      if (!!data) {
        const targets = Array.from(this.querySelectorAll(`[${attr}]`))
        targets.forEach((target) => {
          if (target.tagName === 'ADAPTIVE-IMAGE') {
            target.setAttribute('data-image', data)
          } else if (target.tagName === 'A') {
            target.setAttribute('href', data)
          } else {
            target.innerHTML = data
          }
        })
      }
    })
  }

  _handleHydration() {
    this._selectItems()
    this._initSelectors()
    this._removeListeners()
    this._attachListeners()
    this.classList.add('hydrated')
    this._setURLPostfix()
    return
  }

  _setURLPostfix() {
    const urlPostfix = this.getAttribute('url-postfix')

    if (!!urlPostfix) {
      try {
        const links = this.querySelectorAll('.js-product-card-link')
        for (let i = 0; i < links.length; i++) {
          const link = links[i]
          if (link && !!link.href) {
            const href = new URL(link.href)
            href.searchParams.append(...urlPostfix.split('='))
            link.href = href.toString()
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  }

  _selectItems() {
    this.addToCartToggle = this.querySelector('.js-quick-shop-atc')
    this.quickShopToggle = this.querySelector('.js-toggle-quick-shop')
    this.inCartToggle = this.querySelector('.js-in-cart-toggle')
  }

  get productHandle() {
    return this.getAttribute('product-handle')
  }

  get isSearchProduct() {
    return this.getAttribute('is-search-product') === 'true'
  }

  get shouldHydrate() {
    return this.hasAttribute('hydrate')
  }

  get colorSwatches() {
    return [...this.querySelectorAll('.swatch-element')]
  }

  get variantType() {
    return this.getAttribute('variantType')
  }

  get atcButton() {
    return this.querySelector('.atc-container button')
  }

  get isShowWaitlist() {
    return (
      this.querySelector(`#main-product-data-${this.productId}`)?.dataset
        .showWaitlist === 'true'
    )
  }

  get alwaysShowWaitlist() {
    return Boolean(
      this.querySelector(`#main-product-data-${this.productId}`)?.dataset
        .showWaitlistAlways === 'true'
    )
  }

  get swatchGroupData() {
    return JSON.parse(
      window.atob(this.querySelector(`.swatch-groups-data`)?.innerText)
    )
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  get product() {
    return JSON.parse(
      new Base64().decode(
        this.querySelector(`#main-product-data-${this.productId}`).innerText
      )
    )
  }

  static get observedAttributes() {
    return ['product-handle', 'is-search-product']
  }

  _attachListeners() {
    this.colorSwatches?.forEach((swatch) => {
      swatch.addEventListener('click', this._updateCardVariantState)
    })

    window.addEventListener('resize', this._updateSwatchesCount)
    this.sizeButtons?.forEach((button) =>
      button.addEventListener('click', this._updateCardVariantState)
    )

    this.slideoutToggle = this.querySelector('.swatch-count-container')

    if (this.slideoutToggle) {
      this.slideoutToggle.addEventListener(
        'click',
        this._handleSlideoutToggle.bind(this)
      )
    }

    if (this.inCartToggle) {
      this.inCartToggle.addEventListener('click', this._handleInCartToggle)
    }
  }

  _removeListeners() {
    this.colorSwatches?.forEach((swatch) =>
      swatch.removeEventListener('click', this._updateCardVariantState)
    )

    window.removeEventListener('resize', this._updateSwatchesCount)

    this.sizeButtons?.forEach((button) =>
      button.removeEventListener('click', this._updateCardVariantState)
    )

    if (this.slideoutToggle) {
      this.slideoutToggle.removeEventListener(
        'click',
        this._handleSlideoutToggle.bind(this)
      )
    }

    if (this.inCartToggle) {
      this.inCartToggle.removeEventListener('click', this._handleInCartToggle)
    }
  }

  _updateSwatchesCount(e) {
    e?.preventDefault()

    if (
      !this.slideoutToggle ||
      !this.slideoutToggleVisibleCount ||
      !this.slideoutToggleHiddenCount
    )
      return

    let showCount = this.colorSwatches.length - 3
    if (this.mql.matches) {
      showCount = this.colorSwatches.length - 4
    }
    if (this.mql_m.matches) {
      showCount = this.colorSwatches.length - 6
    }
    if (this.mql_l.matches) {
      showCount = this.colorSwatches.length - 8
    }

    if (showCount > 0) {
      this.slideoutToggleVisibleCount.innerHTML = `+ ${showCount}`
      this.slideoutToggleHiddenCount.innerHTML = showCount
      this.slideoutToggle.classList.remove('hidden')
    } else {
      this.slideoutToggleVisibleCount.innerHTML = ''
      this.slideoutToggleHiddenCount.innerHTML = ''
      this.slideoutToggle.classList.add('hidden')
    }
  }

  _formatCurrency(money) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })

    return formatter.format(money / 100)
  }

  _handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }

  _handleSlideoutFilterKeydown(e) {
    let newButton
    if (e.code === 'ArrowLeft') {
      newButton = e.target
        .closest('li')
        ?.previousSibling?.querySelector('button')
    } else if (e.code === 'ArrowRight') {
      newButton = e.target.closest('li')?.nextSibling?.querySelector('button')
    }

    if (newButton) {
      this._handleSlideoutFilter(newButton, newButton.getAttribute('value'))
    }
  }

  _handleSlideoutFilter(target, category) {
    // Clear active state
    let filterButtons = [
      ...this.slideout.querySelectorAll('.shade-slider button'),
    ]

    filterButtons.forEach((button) => {
      button.classList.remove('active')
      button.setAttribute('tabindex', -1)
      button.setAttribute('aria-selected', 'false')
    })

    // Set active state
    target.classList.add('active')
    target.setAttribute('tabindex', 0)
    target.setAttribute('aria-selected', 'true')
    target.focus()

    // Filter swatches
    let allSlideoutSwatches = [
      ...document.querySelectorAll(
        '.slideout-swatch-selector .swatches-container .swatch-element'
      ),
    ]

    allSlideoutSwatches.forEach((swatch) =>
      swatch.parentElement.classList.remove('hidden')
    )

    if (category !== 'all-shades') {
      allSlideoutSwatches.forEach((swatch) => {
        if (!swatch.classList.contains(this._handleize(category))) {
          swatch.parentElement.classList.add('hidden')
        }
      })
    } else {
      filterButtons[0].classList.add('active')
      filterButtons[0].setAttribute('aria-selected', 'true')
      allSlideoutSwatches.forEach((swatch) => {
        swatch.parentElement.classList.remove('hidden')
      })
    }

    // Select first swatch element after changing tabs
    const firstSwatchRadio = this.slideout.querySelector(
      '.js-slideout-swatches-container li:not(.hidden) .js-swatch-radio'
    )
    if (firstSwatchRadio) {
      firstSwatchRadio.checked = true
      firstSwatchRadio.dispatchEvent(new Event('change'))
    }
  }

  _createSwatchGroupSlider() {
    let categories = this.swatchGroupData
      .split(',')
      .filter((category) => !!category)
    let slider = this.slideout.querySelector(
      '.swatch-category-slider .shade-slider'
    )

    slider.innerHTML = ''

    let tabPanelAriaLabelledBy = `swatch-tab-${this._handleize('All Shades')}`
    let allShadesButtonLi = this._createSwatchFilterButton('All Shades', '0')
    allShadesButtonLi.querySelector('button').classList.add('active')
    allShadesButtonLi
      .querySelector('button')
      .setAttribute('aria-selected', 'true')
    allShadesButtonLi.querySelector('button').addEventListener('click', (e) => {
      this._handleSlideoutFilter(e.target, 'all-shades')
    })
    allShadesButtonLi
      .querySelector('button')
      .addEventListener('keydown', (e) => {
        this._handleSlideoutFilterKeydown(e)
      })

    slider.appendChild(allShadesButtonLi)
    // for each loop over categories and create a slider li element
    categories.forEach((category) => {
      let liElement = this._createSwatchFilterButton(category, '-1')

      slider.appendChild(liElement)

      slider.setAttribute('itemCount', categories.length + 1)
    })

    if (this.slideTabPanel) {
      this.slideTabPanel.setAttribute('id', `main-swatch-tab-panel-${this.productId}`)
    }
  }

  _createSwatchFilterButton(category, tabindex = '0') {
    let buttonElement = document.createElement('button')
    buttonElement.classList.add('bold', 'uppercase', 'text-a2')
    buttonElement.setAttribute('tabindex', tabindex)
    buttonElement.value = this._handleize(category)
    buttonElement.innerText = category

    buttonElement.addEventListener('click', (e) => {
      this._handleSlideoutFilter(e.target, category)
    })
    buttonElement.addEventListener('keydown', (e) => {
      this._handleSlideoutFilterKeydown(e)
    })

    let liElement = document.createElement('li')
    liElement.setAttribute('data-slider-item', '')
    buttonElement.setAttribute('role', 'tab')
    buttonElement.setAttribute('aria-selected', 'false')

    // Update aria controls
    buttonElement.setAttribute('aria-controls', `main-swatch-tab-panel-${this.productId}`)
    liElement.setAttribute('id', `swatch-tab-${this._handleize(category)}`)
    liElement.appendChild(buttonElement)

    return liElement
  }

  _handleSlideoutToggle() {
    this._updateSlideoutContent()
    this._handleNostoAttribution()
  }

  _handleNostoAttribution() {
    const nostoElement = this.closest('.nosto_element')

    if (!nostoElement) return

    this.triggerEvent('click::quick-shop-toggle', {
      product_id: this.productId,
      placement_id: nostoElement.id,
    })
  }

  _updateSlideoutContent() {
    this.slideoutTitle.innerHTML = `<span class="text-glow text-glow--outline" data-text="${this.product.title.replace(
      /â¢/g,
      '™'
    )}">
    <span class="text-glow__inner">${this.product.title.replace(
      /â¢/g,
      '™'
    )}</span>
  </span>`
    this.slideoutSwatches.innerHTML = ''

    this.colorSwatches.forEach((swatch) => {
      let swatchClone = swatch.cloneNode(true)
      let swatchCloneButton = swatchClone.querySelector('.swatch-color-button')
      let bgColor = swatchCloneButton.style.backgroundColor
      let darkTexture =
        swatchCloneButton.style.backgroundImage?.replace('_White.', '.') || ''
      let darkImageTexture =
        swatchCloneButton.src?.replace('_White.', '.') || ''

      let isButtonActive =
        swatchCloneButton.parentElement.parentElement.parentElement.classList.contains(
          'selected'
        )

      swatchCloneButton.style.background = ``
      swatchCloneButton.style.backgroundImage = darkTexture
      swatchCloneButton.src = darkImageTexture
      swatchCloneButton.style.backgroundSize = `cover`
      swatchCloneButton.style.backgroundPosition = `center`
      swatchCloneButton.style.backgroundColor = `${bgColor}`

      // Selected Variant Behavior
      if (isButtonActive) {
        // Update styles of current variant swatch
        // Update text/link of current variant
        this._swapSlideoutFeaturedVariant(swatchCloneButton)
      }

      swatchCloneButton.addEventListener('click', this._updateSlideoutVariant)
      const swatchCloneRadio = swatchCloneButton
        .closest('label')
        ?.querySelector('input[type="radio"]')
      const newId = `${swatchCloneRadio.id}-${Math.floor(
        Math.random() * 10000000
      )}` // Randomize ID to prevent conflict with PLP product card
      swatchCloneRadio.id = newId
      swatchCloneRadio.closest('label').setAttribute('for', newId)
      swatchCloneRadio?.addEventListener(
        'change',
        this._handleSwatchRadioChange.bind(this)
      )
      swatchCloneRadio?.addEventListener(
        'keydown',
        this._handleSwatchRadioKeydown.bind(this)
      )

      let liElement = document.createElement('li')
      liElement.appendChild(swatchClone)

      let spanElement = document.createElement('span')
      spanElement.innerText = swatchCloneButton.dataset.value
      spanElement.classList.add('text-b2')
      liElement.appendChild(spanElement)

      this.slideoutSwatches.appendChild(liElement)
    })

    let offset =
      this.slideoutTitle.offsetHeight +
      this.slideoutHeader.offsetHeight +
      this.slideoutCategories.offsetHeight +
      5
    if (!this.mql.matches) {
      offset += this.slideoutPanel.offsetTop
    }
    this.slideoutSwatchContainer.style.height = `calc(100dvh - ${offset}px)`

    this._createSwatchGroupSlider()

    setTimeout(() => {
      document
        .querySelector('slide-panel[slideout-id="swatch-selector"]')
        .shadowRoot.querySelector('.js-close-slideout')
        .focus()
    }, 1000)
  }

  _swapSlideoutFeaturedVariant(swatch) {
    // Set active state
    let allSlideoutSwatches = [
      ...document.querySelectorAll(
        '.slideout-swatch-selector .swatches-container .swatch-color-button'
      ),
    ]

    let swatchButton = swatch

    allSlideoutSwatches.forEach((swatchButton) => {
      swatchButton.classList.remove('selected')
    })

    swatchButton.classList.add('selected')

    // Get new variant info
    let selectedVariant = this.product.variants.find(
      (variant) => variant.id === parseFloat(swatchButton.dataset.variantId)
    )

    let slideoutVariantInput = document.querySelector(
      '.slideout-swatch-selector .js-selected-variant'
    )

    let slideoutPrice = document.querySelector(
      '.slideout-swatch-selector .atc-price'
    )

    let slideoutFeaturedVariantImage = document.querySelector(
      '.slideout-swatch-selector .atc-featured-variant__image span'
    )

    let slideoutFeaturedVariantTitle = document.querySelector(
      '.slideout-swatch-selector .atc-featured-variant__text .variant-title'
    )
    let slideoutFeaturedVariantDescription = document.querySelector(
      '.slideout-swatch-selector .atc-featured-variant__text .variant-description'
    )
    let slideoutFeaturedVariantLink = document.querySelector(
      '.slideout-swatch-selector .atc-featured-variant__text .variant-link'
    )
    let slideoutFeaturedVariantUrl = document.querySelector(
      '.slideout-swatch-selector .atc-featured-variant__link a'
    )

    slideoutVariantInput.value = selectedVariant.id
    slideoutVariantInput.setAttribute('data-product-id', this.productId)

    slideoutPrice.innerText = `${this._formatCurrency(selectedVariant.price)}`

    slideoutFeaturedVariantImage.style.backgroundColor =
      swatchButton.style.backgroundColor
    slideoutFeaturedVariantImage.style.backgroundImage =
      swatchButton.style.backgroundImage
    slideoutFeaturedVariantImage.style.backgroundPosition =
      swatchButton.style.backgroundPosition
    slideoutFeaturedVariantImage.style.backgroundSize =
      swatchButton.style.backgroundSize

    slideoutFeaturedVariantTitle.innerHTML = swatchButton.dataset.value
    slideoutFeaturedVariantDescription.innerHTML =
      swatchButton?.dataset?.description

    if (swatchButton?.dataset?.description !== '') {
      slideoutFeaturedVariantLink.classList.remove('hidden')
    } else {
      slideoutFeaturedVariantLink.classList.add('hidden')
    }

    slideoutFeaturedVariantUrl.href =
      '/products/' + this.product.handle + '?variant=' + selectedVariant.id

    // Update Add to Cart Button on slideout

    let slideoutAtcButton = document.querySelector(
      '.slideout-swatch__atc button'
    )
    if (
      this.alwaysShowWaitlist ||
      (this.isShowWaitlist && !selectedVariant.available)
    ) {
      slideoutAtcButton.classList.remove(
        'disabled',
        atcStatusTitle.addToBagClass
      )
      slideoutAtcButton.classList.add(...atcStatusTitle.notifyMeClass)
      slideoutAtcButton.removeAttribute('disabled')
      slideoutAtcButton
        .querySelector('.atc-separator')
        .classList.remove('hidden')
      slideoutAtcButton.querySelector('.atc-separator').classList.add('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.notifyMe
      slideoutAtcButton.querySelector('.atc-price').innerText = ''
      slideoutAtcButton.setAttribute('data-target', atcStatusTitle.targetID)
    } else if (!selectedVariant.available) {
      slideoutAtcButton.classList.remove(atcStatusTitle.addToBagClass)
      slideoutAtcButton.classList.add(
        'disabled',
        ...atcStatusTitle.outOfStockClass
      )
      slideoutAtcButton.setAttribute('disabled', true)
      slideoutAtcButton.querySelector('.atc-separator').classList.add('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.outOfStock
      slideoutAtcButton.querySelector('.atc-price').innerText = ''
      slideoutAtcButton.removeAttribute('data-target')
    } else {
      slideoutAtcButton.classList.remove(
        'disabled',
        ...atcStatusTitle.notifyMeClass,
        ...atcStatusTitle.outOfStockClass
      )
      slideoutAtcButton.classList.add(atcStatusTitle.addToBagClass)
      slideoutAtcButton.removeAttribute('disabled')
      slideoutAtcButton
        .querySelector('.atc-separator')
        .classList.remove('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.addToBag
      slideoutAtcButton.querySelector(
        '.atc-price'
      ).innerText = `${this._formatCurrency(selectedVariant.price)}`
      slideoutAtcButton.removeAttribute('data-target')
    }
  }

  _handleSwatchRadioChange(e) {
    const swatchButton = e.target
      .closest('label')
      .querySelector('.swatch-color-button')
    if (swatchButton) {
      this._swapSlideoutFeaturedVariant(swatchButton)
    }
  }

  _handleSwatchRadioKeydown(e) {
    if (e.code === 'Enter') {
      this.slideout
        .querySelector('#slideout-swatch-selector-form')
        ?.dispatchEvent(new Event('submit'))
    }
  }

  _updateSlideoutVariant(e) {
    this._swapSlideoutFeaturedVariant(e.target)
  }

  _updateCardVariantState(e) {
    // Update Active Swatch
    this._clearActiveButton()

    let clickedSwatch = e.target

    let clickedSwatchParent = e.currentTarget.querySelector(
      '.color-select-container'
    )

    clickedSwatchParent.classList.add('selected')

    if (this.sizeButtons.length > 0) {
      clickedSwatchParent = clickedSwatch.parentElement.parentElement
    }

    clickedSwatchParent.classList.add('selected')

    // Only update images if it's a color variant
    if (this.sizeButtons.length === 0) {
      let altTextWeWant = clickedSwatch.dataset.value
      let imagesMatchingAltText = this.product.media.filter((image) =>
        image?.alt?.includes(altTextWeWant)
      )

      let plpImage = imagesMatchingAltText.filter((image) =>
        image?.alt?.includes('| PLP')
      )?.[0]

      plpImage = plpImage ? plpImage : imagesMatchingAltText?.[0]

      let imageOne = { ...imagesMatchingAltText?.[0], loading: 'eager' }

      let imageTwo = { ...imagesMatchingAltText?.[1], loading: 'eager' }

      let mobileImage = { ...plpImage, loading: 'eager' }

      if (imagesMatchingAltText.length > 0 && this.imageOne) {
        this._setNewImage(this.imageOne, imageOne)
        this._setNewImage(this.mobileImage, mobileImage)

        if (!imagesMatchingAltText[1]) {
          this.imageTwo.parentElement.classList.add('hidden')
          this.imageParent.classList.remove('enable-hover')
        } else {
          this.imageTwo.parentElement.classList.remove('hidden')
          this._setNewImage(this.imageTwo, imageTwo)
          this.imageParent.classList.add('enable-hover')
        }
      }
    }

    // Update Pricing + Availability
    let selectedVariant = this.product.variants.find(
      (variant) => variant.id === parseFloat(clickedSwatch.dataset.variantId)
    )

    if (this.selectedVariantInput)
      this.selectedVariantInput.value = selectedVariant.id

    let slideoutAtcButton = document.querySelector(
      '.slideout-swatch__atc button'
    )

    if (
      this.alwaysShowWaitlist ||
      (this.isShowWaitlist && !selectedVariant.available)
    ) {
      this.atcButton.classList.remove('disabled', atcStatusTitle.addToBagClass)
      this.atcButton.classList.add(...atcStatusTitle.notifyMeClass)
      this.atcButton.removeAttribute('disabled')
      this.atcButton.querySelector('span').innerText = atcStatusTitle.notifyMe
      this.atcButton.setAttribute('data-target', atcStatusTitle.targetID)

      slideoutAtcButton.classList.remove(
        'disabled',
        atcStatusTitle.addToBagClass
      )
      slideoutAtcButton.classList.add(...atcStatusTitle.notifyMeClass)
      slideoutAtcButton.removeAttribute('disabled')
      slideoutAtcButton
        .querySelector('.atc-separator')
        .classList.remove('hidden')
      slideoutAtcButton.querySelector('.atc-separator').classList.add('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.notifyMe
      slideoutAtcButton.querySelector('.atc-price').innerText = ''
      slideoutAtcButton.setAttribute('data-target', atcStatusTitle.targetID)
    } else if (!selectedVariant.available) {
      this.atcButton.classList.remove(atcStatusTitle.addToBagClass)
      this.atcButton.classList.add(
        'disabled',
        ...atcStatusTitle.outOfStockClass
      )
      this.atcButton.setAttribute('disabled', true)
      this.atcButton.querySelector('span').innerText = atcStatusTitle.outOfStock
      this.atcButton.removeAttribute('data-target')

      slideoutAtcButton.classList.remove(atcStatusTitle.addToBagClass)
      slideoutAtcButton.classList.add(
        'disabled',
        ...atcStatusTitle.outOfStockClass
      )
      slideoutAtcButton.setAttribute('disabled', true)
      slideoutAtcButton.querySelector('.atc-separator').classList.add('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.outOfStock
      slideoutAtcButton.querySelector('.atc-price').innerText = ''
      slideoutAtcButton.removeAttribute('data-target')
    } else {
      this.atcButton.classList.remove(
        'disabled',
        ...atcStatusTitle.notifyMeClass,
        ...atcStatusTitle.outOfStockClass
      )
      this.atcButton.classList.add(atcStatusTitle.addToBagClass)
      this.atcButton.removeAttribute('disabled')
      this.atcButton.querySelector('span').innerText = atcStatusTitle.addToBag
      this.atcButton.removeAttribute('data-target')

      slideoutAtcButton.classList.remove(
        'disabled',
        ...atcStatusTitle.notifyMeClass,
        ...atcStatusTitle.outOfStockClass
      )
      slideoutAtcButton.classList.add(atcStatusTitle.addToBagClass)
      slideoutAtcButton.removeAttribute('disabled')
      slideoutAtcButton
        .querySelector('.atc-separator')
        .classList.remove('hidden')
      slideoutAtcButton.querySelector('span').innerText =
        atcStatusTitle.addToBag
      slideoutAtcButton.querySelector(
        '.atc-price'
      ).innerText = `${this._formatCurrency(selectedVariant.price)}`
      slideoutAtcButton.removeAttribute('data-target')
    }

    let comparePrice = this.querySelector(
      '[data-compare-at-price]'
    )
    let normalPrice = this.querySelectorAll('.price [data-regular-price]')
    const priceContainer = this.querySelector('[data-price-container]')
    const priceSaleContainer = this.querySelector('[data-price-sale-container]')
    normalPrice.forEach((el) => {
      el.innerText = `${this._formatCurrency(selectedVariant.price)}`
    })
    if (selectedVariant?.compare_at_price) {
      comparePrice.classList.remove('hidden')
      priceContainer.classList.add('price--on-sale');
      priceSaleContainer.classList.remove('hidden');

      comparePrice.innerText = `${this._formatCurrency(
        selectedVariant.compare_at_price
      )}`

    } else {
      comparePrice.classList.add('hidden')
      priceContainer.classList.remove('price--on-sale');
      priceSaleContainer.classList.add('hidden');
    }

    // Update Variant text or hide text

    let variantText = this.querySelector('.product-card__current-variant-title')
    variantText.innerText = selectedVariant.title
  }

  _setNewImage(wrapper, image) {
    const img = wrapper.querySelector('img')
    img.setAttribute('srcset', this._generateSrcset(image.src, image.width))
    img.setAttribute('src', image.src)
    img.setAttribute('alt', image.alt)
  }

  _generateSrcset(src, imgWidth) {
    let srcset = ''
    const srcsetWidths = [493, 600, 713, 823, 1100, 1206, 1346, 1426, 1646, 1946]

    for (const width of srcsetWidths) {
      if (imgWidth >= width) srcset += `${src}&width=${width} ${width}w,`
    }
    srcset += `${src} ${imgWidth}w`
    return srcset
  }

  _clearActiveButton() {
    if (this.sizeButtons.length === 0) {
      this.colorSwatches.forEach((swatch) => {
        swatch
          .querySelector('.color-select-container')
          .classList.remove('selected')
      })
    } else {
      this.sizeButtons.forEach((button) => {
        button.parentElement.parentElement.classList.remove('selected')
      })
    }
  }

  async _handleInCartToggle(e) {
    try {
      e.preventDefault()
      if (this.miniCart) {
        this.miniCart.setAttribute('loading', true)
      }
      this.inCartToggle.setAttribute('disabled', true)
      const cartLineItemKey = e.currentTarget.dataset.lineItemKey
      const cartItemsToRemove = (e.currentTarget.dataset.itemsToRemove || '')
        .split(',')
        .filter(Boolean)
      const property = this.inCartToggle.dataset.lineProperty
      if (cartItemsToRemove.length) {
        await window.__CART__CONTROLLER__.updateQuantity(
          cartItemsToRemove.reduce((acc, item) => {
            acc[item] = 0
            return acc
          }, {})
        )
      }
      if (cartLineItemKey) {
        await window.__CART__CONTROLLER__.updateQuantity(
          cartLineItemKey,
          0,
          true
        )
      } else {
        const payload = {
          id: this.inCartToggle.dataset.value,
          quantity: 1,
          ...(property ? { properties: { [property]: true } } : {}),
        }
        await window.__CART__CONTROLLER__.add({ payload })
      }

      this.triggerGlobalEvent('main-cart::refresh')
    } finally {
      if (this.miniCart) {
        this.miniCart.removeAttribute('loading')
      }
      this.inCartToggle.setAttribute('disabled', false)
    }
  }
}

window.customElements.define('product-card', ProductCard)
